import app from 'flarum/forum/app';
import Page from 'flarum/forum/components/Page';
import Button from 'flarum/common/components/Button';
import icon from 'flarum/common/helpers/icon';

import AddApplicationModal from '../components/AddApplicationModal';
import ApplicationList from '../components/ApplicationList';

export default class ApplicationsPage extends Page {
    oninit(vnode) {
        super.oninit(vnode);

        app.history.push('applications', icon('fas fa-th'));

        app.setTitle(app.translator.trans('xtreh-phoenix.forum.applications.label'));
        app.setTitleCount(0);

        // load user with serialized applications
        app.store.find('users', app.session.user?.id()).then(() => { m.route.set(m.route.get()); /* there are bug in mithril, normally should use m.redraw() */ });
    }

    view() {
        const applications = app.session.user.applications();

        return (
            <div className='ApplicationsPage'>
                <div className='ApplicationList'>
                    <div className='ApplicationList-header'>
                        <h4 className='App-titleControl App-titleControl--text'> { app.translator.trans('xtreh-phoenix.forum.applications.label') }</h4>
                    </div>
                    <nav className="ApplicationsPage-nav sideNav">
                        <ul>
                            <li className='item-addApplication App-primaryControl'>
                                <Button icon="fas fa-plus" className="Button Button--primary ApplicationsPage-addApplication" itemClassName="App-primaryControl" onclick={() => { app.modal.show(AddApplicationModal); }}>
                                    { app.translator.trans('xtreh-phoenix.forum.applications.add.title') }
                                </Button>
                            </li>
                        </ul>
                    </nav>
                    <div className='ApplicationList-content'>
                        <ApplicationList applications={applications} />
                    </div>
                </div>
            </div>
        );
    }

    content() {}
}
